<template>
  <div class="warehouse-order-article -header">
    <div class="warehouse-order-article_description">
      <div class="ml-2">
        <HeaderLabel :text="$t('sl.warehouse.headers.label')"/>
      </div>
    </div>

    <div class="warehouse-order-article_unit">
      <HeaderLabel :text="$t('sl.warehouse.headers.unit')"/>
    </div>

    <div class="warehouse-order-article_demand">
      <HeaderLabel :text="$t('sl.warehouse.headers.demand')"/>
    </div>

    <div class="warehouse-order-article_demand">
      <HeaderLabel :text="$t('sl.warehouse.headers.demand')"/>
    </div>

    <div class="warehouse-order-article_due">
      <HeaderLabel :text="$t('sl.warehouse.headers.due')"/>
    </div>

    <div class="warehouse-order-article_spacer">
    </div>

    <div class="warehouse-order-article_picked">
      <HeaderLabel :text="$t('sl.warehouse.headers.picked')"/>
    </div>

    <div class="warehouse-order-article_completed">
      <HeaderLabel :text="$t('sl.warehouse.headers.completed')"/>
    </div>

    <div class="warehouse-order-article_delete">
      <HeaderLabel :text="$t('sl.warehouse.headers.delete')"/>
    </div>
  </div>
</template>

<script>
import ArticleImage from "@/components/SmartLogistics/Article/ArticleImage.vue";
import ArticleCaption from "@/components/SmartLogistics/Article/ArticleCaption.vue";
import HeaderLabel from "@/components/SmartLogistics/Design/HeaderLabel.vue";

export default {
  name: 'OrderArticleHeader',
  components: {HeaderLabel, ArticleCaption, ArticleImage},
}
</script>